<div class="ps-logo" [class]="[sizeClass(), variantClass()]">
  <img [src]="src()" alt="Purespectrum" class="ps-logo-img" />
</div>
